import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-config',
  templateUrl: './leave-config.component.html',
  styleUrls: ['./leave-config.component.scss']
})
export class LeaveConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
